import {
  GET_NODE_EDGE,
  GET_NODE_EDGE_SUCCESS,
  GET_NODE_EDGE_ERROR,
  UPDATE_NODE_EDGE,
  UPDATE_NODE_EDGE_SUCCESS,
  UPDATE_NODE_EDGE_ERROR,
  
} from "../actions";

export const getNodeEdge = (edgeId) => ({
    type: GET_NODE_EDGE,
    payload: { edgeId},
  });

export const getNodeEdgeSuccess = (nodeEdge) => ({
  type: GET_NODE_EDGE_SUCCESS,
  payload: nodeEdge,
});

export const getNodeEdgeError = (message) => ({
  type: GET_NODE_EDGE_ERROR,
  payload: { message },
});

export const updateNodeEdge = (nodeEdge, history, collection_id) => ({
    type: UPDATE_NODE_EDGE,
    payload: {nodeEdge, history, collection_id}
  });

export const updateNodeEdgeSuccess = (nodeEdgeCreated) => ({
  type: UPDATE_NODE_EDGE_SUCCESS,
  payload: nodeEdgeCreated,
});

export const updateNodeEdgeError = (message) => ({
  type: UPDATE_NODE_EDGE_ERROR,
  payload: { message },
});

